import React from 'react';
import { Box, Typography } from '@mui/material';

export function editorFileNameForLanguage(language) {
  switch (String(language || '').toLowerCase()) {
    case 'python':
      return 'main.py';
    case 'c':
      return 'main.c';
    case 'cpp':
      return 'main.cpp';
    case 'java':
      return 'Main.java';
    case 'javascript':
      return 'main.js';
    case 'typescript':
      return 'main.ts';
    case 'html':
      return 'index.html';
    case 'css':
      return 'styles.css';
    case 'go':
      return 'main.go';
    case 'rust':
      return 'main.rs';
    default:
      return 'main.txt';
  }
}

export default function EditorBreadcrumb({ fileName }) {
  const segments = String(fileName || 'untitled')
    .split(/[\\/]+/)
    .filter(Boolean);

  return (
    <Box
      sx={{
        px: 1.5,
        py: 0.75,
        bgcolor: '#252526',
        borderBottom: '1px solid #3C3C3C',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
      }}
    >
      {segments.map((segment, index) => (
        <React.Fragment key={`${segment}-${index}`}>
          {index > 0 ? (
            <Typography
              component="span"
              sx={{ color: '#858585', fontSize: 12, mx: 0.5 }}
            >
              ›
            </Typography>
          ) : null}
          <Typography
            component="span"
            sx={{
              color: index === segments.length - 1 ? '#CCCCCC' : '#858585',
              fontSize: 12,
              fontWeight: index === segments.length - 1 ? 600 : 400,
            }}
          >
            {segment}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
  );
}
